export function getPredictedCostUsd(value: unknown): number | null {
  if (value == null) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function formatPredictedCostUsd(value: unknown): string {
  const cost = getPredictedCostUsd(value);
  if (cost == null) return '—';
  if (cost === 0) return '$0.00';
  if (cost < 0.01) return `$${cost.toFixed(4)}`;
  return `$${cost.toFixed(2)}`;
}

export function pricingModelTooltip(pricingModelName: string | null | undefined): string | undefined {
  const name = typeof pricingModelName === 'string' ? pricingModelName.trim() : '';
  return name ? `Priced at ${name}` : undefined;
}
